import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Upload from "../../../assets/upload.png";
import Resizer from "react-image-file-resizer";
import { useMutation, gql } from "@apollo/client";
import Spinner from "../../Modals/SpinnerModal";
const Container = styled.div`
  width: 100%;
  height: 85vh;
`;
const AllProducts = styled.div`
  width: 103%;
  height: 86%;
  margin-top: 10px;
  overflow-y: scroll;
  display: flex;
  flex-flow: wrap;
  flex-direction: row;
  align-content: flex-start;
`;
const InputBox = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 10px;
`;
const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
`;
const Input1 = styled.input`
  width: 45%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
  float: left;
`;
const Input2 = styled.input`
  width: 45%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
  float: right;
`;
const Description = styled.textarea`
  width: 97.5%;
  height: 200px;
  border: none;
  outline: none;
  padding: 1%;
  font-size: 1.1em;
  border: 1px solid #ccc;
  margin: 10px 0;
  resize: none;
  font: inherit;
  border-radius: 5px;
`;
const InputFile = styled.input`
  &{
    width: 98.5%;
    border: none;
    outline: none;
    padding: 20px 0 5px 0;
    font-size: 1.1em;
    color rde;
  }
  &::-webkit-visibility {
   hidden
}
  &before{
    content: 'Select some files';
  color: black;
  display: inline-block;
  background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
  border: 1px solid #999;
  border-radius: 3px;
  padding: 5px 8px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
  text-shadow: 1px 1px #fff;
  font-weight: 700;
  font-size: 10pt;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 13px 10px;
  background: #f97a7a;
  color: white;
  font-size: 1.1em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 20px 0;
`;
const Header = styled.div`
  width: 100%;
  height: 50px;
`;
const HeaderTitle = styled.h2`
  float: left;
  margin: 0;
  padding: 0;
  font-weight: 500;
`;

const AddNewButton = styled.button`
  float: right;
  padding: 10px 20px;
  background: #f97a7a;
  color: white;
  font-size: 0.9em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 5px 0;
`;

const ImageView = styled.div`
  width: 100%;
  height: 200px;
`;
const UploadButton = styled.div`
  width: 20%;
  margin-left: 40%;
  text-align: center;
  padding-top: 40px;
  cursor: pointer;
`;
const ImagePreview = styled.div`
  width: 35%;
  height: 100%;
  background: #f8f8f8;
  float: right;
  text-align: center;
  border-radius: 5px;
  overflow: hidden;
  display: none;
`;
const AddTitele = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 1.2em;
  font-weight: 500;
  color: #f97a7a;
`;
const ImageBox2 = styled.div`
  width: 23%;
  padding: 20px 0;
  background: rgb(180, 177, 177);
  text-align: center;
  border-radius: 5px;
`;
const ImageBox = styled.div`
  width: 23%;
  height: 140px;
  background: rgb(180, 177, 177);
  @keyframes mymove {
    from {
      background-color: #e6e1e1;
    }
    to {
      background-color: #c7caca;
    }
  }
  animation: mymove 1s infinite;
  margin: 0 2% 2% 0;
  border-radius: 5px;
  @media (max-width: 789px) {
    width: 45%;
    height: 150px;
  }
`;
const Image = styled.img`
  width: 22.5%;
  height: 140px;
  margin: 0 2% 2% 0;
  border-radius: 5px;
  border: 1px solid #ccc;
  @media (max-width: 789px) {
    width: 45%;
    height: 150px;
  }
`;

const UPLOAD_FILE = gql`
  mutation uploadToAws($file: Upload!) {
    uploadToAws(file: $file) {
      url
    }
  }
`;

function EditProduct(props) {
  let imageBoxes = [];
  const [findProduct, setProduct] = useState({});
  const [name, setName] = useState("");
  const [price, setPrice] = useState(null);
  const [measure, setMeasure] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [categoryId, setCategoryId] = useState(null);
  const [subCatId, setSubCatId] = useState(null);
  const [subId, setSubId] = useState(null);
  const [brandName, setBrandName] = useState("");
  const [brandId, setBrandId] = useState(null);
  const [addProductModal, setAddProductModal] = useState(false);
  const [uploadDone, setUploadDone] = useState(false);
  const [productImage, setProductImage] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubcats] = useState([]);
  const [imageUpload, setUpload] = useState(false);
  const [images, setImages] = useState([]);
  const [totalImages, setTotalImages] = useState(0);
  const [description, setDescription] = useState("");
  const [editProduct, setEditProduct] = useState(false);
  const [editProductValues, setValues] = useState({});

  const nameChangeHandler = (e) => {
    setName(e.target.value);
    const product = findProduct;
    findProduct.name = e.target.value;
    setProduct(product);
  };
  const priceChangeHandler = (e) => {
    setPrice(e.target.value);
    findProduct.price = e.target.value;
  };
  const descriptionHandler = (e) => {
    setDescription(e.target.value);
    findProduct.description = e.target.value;
  };
  const categoryChangeHandler = (e) => {
    let index = e.target.value;
    setCategoryId(index);
    setSubcats(categories[index].subCategories);
  };

  const SubCatChangeHandler = (e) => {
    setSubCatId(e.target.value);
  };
  const brandChangeHandler = (e) => {
    setBrandName(e.target.value);
    findProduct.brandName = e.target.value;
  };
  const measureChangeHandler = (e) => {
    setMeasure(e.target.value);
    findProduct.measurment = e.target.value;
  };

  const addProductHandler = () => {};
  useEffect(() => {
    setProduct(props.product);
    setEditProduct(props.product);
  });
  //Image upload
  const [uploadToAws] = useMutation(UPLOAD_FILE, {
    onCompleted: (data) => {
      console.log(data);
      setProductImage(data.uploadToAws.url);
      setUploadDone(true);
      const newImages = images;
      newImages.push(data.uploadToAws.url);
      setImages(newImages);
      findProduct.images = newImages;
      console.log("images", newImages);
      setTotalImages(totalImages - 1);
    },
  });
  const resizeFile = (file) =>
    new Promise(async (resolve) => {
      await Resizer.imageFileResizer(
        file,
        1400,
        1200,
        "WEBP",
        100,
        0,
        (uri) => {
          // resolve(uri);
          console.log("UK uri", uri);
          const file = uri;
          console.log("UK uri 1", file);
          uploadToAws({ variables: { file } });
        },
        "file"
      );
    });
  const handleFileChange = async (e) => {
    debugger;
    setUpload(true);
    setSpinner(true);
    const files = e.target.files;
    setTotalImages(e.target.files.length);
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      resizeFile(file);
      console.log("resize", file);
      //uploadToAws({ variables: { file } });
    }
    setTimeout(() => {
      setSpinner(false);
    }, 5000);
  };
  const updateHandler = () => {
    props.productUpdateHandler(findProduct);
    setTimeout(() => {
      setUploadDone(false);
      setUpload(false);
      setImages([]);
    }, 2000);
  };
  return (
    findProduct && (
      <div className="EditProduct">
        <Spinner show={spinner} />
        <AddTitele>Edit product</AddTitele>
        {/* <form> */}
        {!imageUpload ? (
          <ImageView>
            <UploadButton>
              <label for="file-input">
                <img style={{ width: "70px", height: "70px" }} src={Upload} />
              </label>
              <input
                id="file-input"
                className="custom-file-input"
                // required="true"
                type="file"
                multiple
                onChange={handleFileChange}
                accept="image/x-png,image/gif,image/jpeg"
              />
            </UploadButton>
            <ImagePreview>
              {uploadDone ? (
                <img
                  style={{ width: "100%", height: "100%" }}
                  src={productImage}
                  alt="productimage"
                />
              ) : null}
            </ImagePreview>
          </ImageView>
        ) : (
          <div
            style={{
              width: "103%",
              display: "flex",
              margin: "20px 0",
              flexFlow: "wrap",
              height: "auto",
              flexDirection: "row",
            }}
          >
            {images.map((img) => (
              <Image src={img} />
            ))}
            {/* {imageBoxes} */}
          </div>
        )}
        <p className="leftLabel">Product name</p>
        <Input
          value={findProduct.name}
          onChange={nameChangeHandler}
          // required="true"
          type="text"
          placeholder="Product name"
        />
        <div>
          <p className="leftLabel">Measurement</p>
          <p className="rightLabel">Price</p>
        </div>
        <InputBox>
          <Input1
            value={findProduct.measurment}
            onChange={measureChangeHandler}
            // required="true"
            type="text"
            placeholder="Measurement"
          />
          <Input2
            onChange={priceChangeHandler}
            value={findProduct.price}
            // required="true"
            type="number"
            min="0"
            placeholder="Product price"
          />
        </InputBox>

        <select
          className="Category"
          // required="true"
          onChange={categoryChangeHandler}
        >
          <option value="">Select Category </option>
          {categories.map((category, id) => {
            return <option value={id}>{category.name}</option>;
          })}
        </select>
        <select
          className="Brand"
          // required="true"
          onChange={SubCatChangeHandler}
        >
          <option value="">Select Subcategory</option>
          {subCategories.map((sub, id) => {
            return <option value={id}>{sub.name}</option>;
          })}
        </select>
        <p className="leftLabel">Brand</p>
        <Input
          value={findProduct.brandName}
          onChange={brandChangeHandler}
          // required="true"
          type="text"
          placeholder="Brand name"
        />
        <p className="leftLabel">Description</p>
        <Description
          value={findProduct.description}
          onChange={descriptionHandler}
          type="text"
          name={description}
          placeholder="Description"
        />

        <Button onClick={updateHandler}>Save changes</Button>
        {/* </form> */}
      </div>
    )
  );
}
export default EditProduct;
